import { ValidationSchemaType } from 'hooks/useForm';
import { Product } from '../types/dtos';

export const PRODUCT_INITIAL_FIELDS: Product = {
    name: '',
    websiteId: '',
    description: '',
    productCategoryId: '',
};

export const PRODUCT_FIELDS_SCHEMA: ValidationSchemaType<Product> = {
    name: {
        required: true,
        maxLength: 100,
    },
    productCategoryId: {
        required: true,
    },
};
